import cx from 'classnames'

const IconWrapper = ({ hasMargin = true, isSuffix = false, children }) => (
  <span
    className={cx(
      'min-w-max flex',
      { 'mr-2': hasMargin },
      { 'ml-2': isSuffix }
    )}
  >
    {children}
  </span>
)

export default IconWrapper
